module.exports = __webpack_public_path__ + "b863287141dbd48274a8639f1f913fc8.svg";